// ---------------------------------------------------------------------------
// Listing card size
// ---------------------------------------------------------------------------
// How large restaurant photos appear on the listings page, set by an admin and
// applied site-wide. It is a judgement call rather than a technical one —
// bigger photos sell a restaurant harder, smaller ones let people scan more
// listings without scrolling — so it lives in config rather than in code.
//
// Stored at config/appearance, which firestore.rules already exposes as public
// read / admin write.
// ---------------------------------------------------------------------------

export const CARD_SIZES = [
  {
    id: 'small',
    label: 'Small',
    hint: 'Compact rows with a square thumbnail. The most listings per screen — best for scanning ratings.',
  },
  {
    id: 'comfortable',
    label: 'Comfortable',
    hint: 'One listing per row with a wide photo. Room for the food to read without losing the row layout.',
  },
  {
    id: 'medium',
    label: 'Medium',
    hint: 'Photo tiles, two per row on a phone. A balance of browsing and detail.',
  },
  {
    id: 'large',
    label: 'Large',
    hint: 'Taller photos. Fewer listings visible, but each one sells harder.',
  },
  {
    id: 'xlarge',
    label: 'Extra large',
    hint: 'Full-width photos, one per row on a phone. Matches the original site.',
  },
];

// Option A — the direction that was signed off. Compact rows, square
// thumbnail, and the rating in a right-hand column.
export const DEFAULT_CARD_SIZE = 'small';

export function isCardSize(value) {
  return CARD_SIZES.some(size => size.id === value);
}

export function normalizeCardSize(value) {
  return isCardSize(value) ? value : DEFAULT_CARD_SIZE;
}

// `small` and `comfortable` are row layouts — thumbnail left, rating in a
// right-hand column so the stars line up down the page. Everything above
// them is a photo tile, which changes both the card's internals and how the
// grid columns are counted.
const ROW_LAYOUTS = ['small', 'comfortable'];

export function isRowLayout(size) {
  return ROW_LAYOUTS.includes(normalizeCardSize(size));
}
